import { fetchConToken } from "../helpers/fetch"

const CredencialesService = {
    getCredenciales:()=>{
        return fetchConToken(`Credenciales`)
    },
    getCredencialesByIdAfiliado:(idAfiliado)=>{
        return fetchConToken(`Credenciales/TraerCredencialPorIdAfiliado/${idAfiliado}`)
    }
}

export {CredencialesService as default}